module.exports = __webpack_public_path__ + "img/nav-vehcile-models-homepage-hyundai.f1f1506f.png";